/**
 * Visible H2 pair for quote journeys — matches ICUK “Website Heading” SEO brief
 * (“Why Get Your Quote Through ICUK?” + “Start Your … Quote”).
 * Render once at the top of the wizard (below optional dev test-data controls).
 *
 * @param {{ startYourQuoteHeading: string }} props
 */
export default function QuoteFormSeoIntro({startYourQuoteHeading}) {
   return (
      <section
         className="quote-form-seo-intro text-center mb-4"
         aria-labelledby="quote-seo-why-icuk-heading"
      >
         <h2 id="quote-seo-why-icuk-heading" className="h4 mb-2">
            Why Get Your Quote Through ICUK?
         </h2>
         <h2 className="h5 mb-0 text-secondary">{startYourQuoteHeading}</h2>
      </section>
   );
}
